function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 30C0 13.431 13.431 0 30 0h380c16.569 0 30 13.431 30 30v121a5 5 0 01-5 5H30c-16.569 0-30-13.431-30-30V30z",
  fill: "#F7F8F9",
  opacity: 0.95
});

function SvgHomeGoodWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 156,
    viewBox: "0 0 440 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQwIiBoZWlnaHQ9IjE1NiIgdmlld0JveD0iMCAwIDQ0MCAxNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIG9wYWNpdHk9IjAuOTUiPgo8cGF0aCBkPSJNMCAzMEMwIDEzLjQzMTUgMTMuNDMxNSAwIDMwIDBINDEwQzQyNi41NjkgMCA0NDAgMTMuNDMxNSA0NDAgMzBWMTUxQzQ0MCAxNTMuNzYxIDQzNy43NjEgMTU2IDQzNSAxNTZIMzBDMTMuNDMxNSAxNTYgMCAxNDIuNTY5IDAgMTI2VjMwWiIgZmlsbD0iI0Y3RjhGOSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgHomeGoodWork as ReactComponent };